module.exports = __webpack_public_path__ + "static/media/not-desktop-img.ae52fe61.png";